export const mergeArrays: <T>(arrays: T[][]) => T[] = <T>(arrays: T[][]) => {
  const mergedArray: T[] = [];

  arrays.forEach((array) => mergedArray.push(...array));

  return mergedArray;
};
